import { useState, useEffect, MutableRefObject } from 'react';

export function useIsVisible(
  ref: MutableRefObject<Element | undefined>,
  destroyAfterFirst = false
) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);
      if (destroyAfterFirst && entry.isIntersecting) {
        observer?.disconnect();
      }
    });

    if (ref && ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [destroyAfterFirst, ref]);

  return isIntersecting;
}
